import { useEffect, useState } from "react";

export interface ConfirmDeleteModalProps {
  open: boolean;
  drugApiName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isPending?: boolean;
}

export function ConfirmDeleteModal({
  open,
  drugApiName,
  onConfirm,
  onCancel,
  isPending,
}: ConfirmDeleteModalProps) {
  const [typed, setTyped] = useState("");

  // Reset typed input when modal closes or target project changes.
  useEffect(() => {
    if (!open) setTyped("");
  }, [open, drugApiName]);

  if (!open) return null;
  const matches = typed.trim() === drugApiName.trim();

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-50 anim-fade flex items-start justify-center pt-24 px-6"
      style={{ background: "rgba(10,10,10,0.4)" }}
      onClick={onCancel}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-[var(--paper)] border border-[var(--ink)] w-full max-w-md page-edge anim-rise"
      >
        <div className="px-8 py-5 border-b-2 border-[var(--ink)]">
          <div className="eyebrow">§ Exclusão</div>
          <div className="display-4 mt-1">Excluir monografia</div>
        </div>
        <div className="px-8 py-6 space-y-4">
          <p className="body">
            Para confirmar a exclusão, digite o nome do API:{" "}
            <strong className="serif italic">{drugApiName}</strong>
          </p>
          <input
            autoFocus
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            aria-label="Confirme digitando o nome do API"
            placeholder={drugApiName}
            className="w-full bg-transparent border border-[var(--rule)] focus:border-[var(--ink)] px-3 py-2 text-[14px] mono transition-colors"
          />
        </div>
        <div className="px-8 py-4 border-t border-[var(--rule)] flex items-center justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isPending}
            className="px-4 py-2 caption border border-[var(--rule)] hover:border-[var(--ink)] disabled:opacity-50 transition-colors"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={!matches || isPending}
            className="px-4 py-2 caption bg-[var(--strike)] text-[var(--paper)] disabled:opacity-40 disabled:cursor-not-allowed transition-opacity"
          >
            {isPending ? "Excluindo…" : "Excluir"}
          </button>
        </div>
      </div>
    </div>
  );
}
